import { ChevronRight } from 'lucide-react';

import { ru } from '@/i18n/ru';
import { pathSegments } from '@/lib/format';

interface BreadcrumbProps {
  path: string;
  onNavigate: (path: string) => void;
}

export function Breadcrumb({ path, onNavigate }: BreadcrumbProps) {
  const segments = pathSegments(path);

  return (
    <nav className="flex min-w-0 items-center gap-1 text-xs" aria-label={ru.breadcrumb}>
      <button
        type="button"
        onClick={() => onNavigate('')}
        className="shrink-0 text-text-muted hover:text-accent focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent"
      >
        {ru.root}
      </button>
      {segments.map((seg, i) => {
        const full = segments.slice(0, i + 1).join('/');
        const isLast = i === segments.length - 1;
        return (
          <span key={full} className="flex min-w-0 items-center gap-1">
            <ChevronRight className="h-3 w-3 shrink-0 text-text-muted/50" />
            {isLast ? (
              <span className="truncate text-text font-medium">{seg}</span>
            ) : (
              <button
                type="button"
                onClick={() => onNavigate(full)}
                className="truncate text-text-muted hover:text-accent focus-visible:outline focus-visible:outline-1 focus-visible:outline-accent"
              >
                {seg}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
